import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import { ViewModalModule } from '../view-modal/view-modal.module';
import { IneligibilityModalComponent } from './ineligibility-modal.component';

@NgModule({
  declarations: [IneligibilityModalComponent],
  imports: [CommonModule, ViewModalModule, ButtonModule],
  exports: [IneligibilityModalComponent]
})
export class IneligibilityModalModule {}
